import { Injectable } from "@angular/core";

import { Subject } from "rxjs";

import jwt_decode from "jwt-decode";
import { NewCustomer } from "src/models/newcustomer";

@Injectable()
export class Helpers {
  private authenticationChanged = new Subject<boolean>();

  constructor() {}

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  public isAuthenticated(): boolean {
    return !(
      window.localStorage.token === undefined ||
      window.localStorage.token === null ||
      window.localStorage.token === "null" ||
      window.localStorage.token === "undefined" ||
      window.localStorage.token === ""
    );
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (
      window.localStorage.token === undefined ||
      window.localStorage.token === null ||
      window.localStorage.token === "null" ||
      window.localStorage.token === "undefined" ||
      window.localStorage.token === ""
    ) {
      return "";
    }

    const obj = JSON.parse(window.localStorage.token);
    return obj.token;
  }

  public setPushNotificationToken(data: any): void {
    window.localStorage.pushToken = JSON.stringify(data);
  }

  public getPushNotificationToken(): any {
    if (
      window.localStorage.pushToken === undefined ||
      window.localStorage.pushToken === null ||
      window.localStorage.pushToken === "null" ||
      window.localStorage.pushToken === "undefined" ||
      window.localStorage.pushToken === ""
    ) {
      return "";
    }

    const obj = JSON.parse(window.localStorage.pushToken);

    return obj.token;
  }

  public setToken(data: any): void {
    this.setStorageToken(JSON.stringify(data));
  }

  public failToken(): void {
    this.setStorageToken(undefined);
  }

  public logout(): void {
    window.localStorage.email = undefined;
    this.setStorageToken(undefined);
  }

  private setStorageToken(value: any): void {
    window.localStorage.token = value;

    this.authenticationChanged.next(this.isAuthenticated());
  }

  public setEmail(value: any): void {
    window.localStorage.email = value;
  }

  public getEmail(): string {
    return window.localStorage.email;
  }

  public setName(value: any): void {
    window.localStorage.name = value;
  }

  public getName(): string {
    return window.localStorage.name;
  }

  public setCompanyId(value: number): void {
    window.localStorage.companyId = value;
  }

  public getCompanyId(): number {
    return window.localStorage.companyId;
  }

  public setId(value: any): void {
    window.localStorage.id = value;
  }

  public getId(): string {
    return window.localStorage.id;
  }

  public setAgentFullName(value: string): void {
    window.localStorage.agentFullName = value;
  }

  public getAgentFullName(): string {
    return window.localStorage.agentFullName;
  }

  public setAgentCode(value: string) {
    window.localStorage.agentCode = value;
  }
  public getAgentCode(): string {
    return window.localStorage.agentCode;
  }
  public setGtsBearerToken(value: string): void {
    window.localStorage.gtsBearerToken = value;
  }

  public getGtsBearerToken(): string {
    return window.localStorage.gtsBearerToken;
  }

  public setProducts(value: string[]): void {
    window.localStorage.products = JSON.stringify(value);
  }

  public getProducts(): string[] {
    if (
      window.localStorage.products === undefined ||
      window.localStorage.products === null ||
      window.localStorage.products === "null" ||
      window.localStorage.products === "undefined" ||
      window.localStorage.products === ""
    ) {
      return [];
    }
    try {
      const products = JSON.parse(window.localStorage.products);
      if (Array.isArray(products)) {
        return products;
      }
      return [];
    } catch (error) {
      console.error("Error parsing products from localStorage:", error);
      return [];
    }
  }

  public appendImportedData(data: NewCustomer[]): void {
    const agencyId = this.getAgencyId();
    console.log("APPENDING IMPORTED DATA FOR AGENCY ID: ", agencyId);
    const importedData = window.localStorage.importedData
      ? JSON.parse(window.localStorage.importedData)
      : {};
    const existingData = importedData[agencyId];
    let newData: NewCustomer[] = [];
    data = data.map((item) => {
      return {
        ...item,
        userId: this.getId(),
      };
    });
    if (existingData) {
      newData = [...existingData, ...data];
    } else {
      newData = data;
    }
    importedData[agencyId] = newData;
    window.localStorage.importedData = JSON.stringify(importedData);
  }
  public replaceImportedData(data: NewCustomer[]): void {
    const agencyId = this.getAgencyId();
    const userId = this.getId();

    console.log("REPLACING IMPORTED DATA FOR KEY: ", agencyId, userId);
    const importedData = window.localStorage.importedData
      ? JSON.parse(window.localStorage.importedData)
      : {};
    const agencyData = importedData[agencyId];
    if (agencyData) {
      const userType = this.getDecodedAccessToken(
        window.localStorage.token
      )?.type;
      if (userType.indexOf("LEVEL 0") === 0) {
        const exceptMyUserData = agencyData.filter(
          (item: NewCustomer) => item.userId !== userId
        );
        if (exceptMyUserData.length > 0) {
          data = data.map((item) => {
            return {
              ...item,
              userId: this.getId(),
            };
          });
          exceptMyUserData.push(...data);
          importedData[agencyId] = exceptMyUserData;
        }
      } else {
        importedData[agencyId] = data;
      }
    }
    window.localStorage.importedData = JSON.stringify(importedData);
  }

  public getImportedData(filter?: string): NewCustomer[] {
    const importedData = window.localStorage.importedData;
    if (importedData) {
      const data = JSON.parse(importedData);

      const userType = this.getDecodedAccessToken(
        window.localStorage.token
      )?.type;

      const agencyId = this.getAgencyId();
      if (userType.indexOf("LEVEL 0") === 0) {
        return (this._getImportedData(data, agencyId, filter) ?? []).filter(
          (item) => item.userId === this.getId()
        );
      } else {
        return this._getImportedData(data, agencyId, filter) ?? [];
      }
    }
    return [];
  }

  public getMyImportedData(filter?: string): NewCustomer[] {
    const importedData = window.localStorage.importedData;
    if (importedData) {
      const data = JSON.parse(importedData);
      const agencyId = this.getAgencyId();
      return (this._getImportedData(data, agencyId, filter) ?? []).filter(
        (item) => item.userId === this.getId()
      );
    }
    return [];
  }

  private _getImportedData(
    data: any,
    key: string,
    filter?: string
  ): NewCustomer[] {
    if (data[key]) {
      if (filter) {
        return data[key]
          .filter(
            (item: NewCustomer) =>
              item.plateNumber?.toLowerCase().includes(filter.toLowerCase()) ||
              item.ownerName?.toLowerCase().includes(filter.toLowerCase()) ||
              item.chassisNumber
                ?.toLowerCase()
                .includes(filter.toLowerCase()) ||
              item.email?.toLowerCase().includes(filter.toLowerCase()) ||
              item.phoneNumber1?.toLowerCase().includes(filter.toLowerCase()) ||
              item.phoneNumber2?.toLowerCase().includes(filter.toLowerCase()) ||
              item.phoneNumber3?.toLowerCase().includes(filter.toLowerCase()) ||
              item.phoneNumber4?.toLowerCase().includes(filter.toLowerCase()) ||
              item.carMake?.toLowerCase().includes(filter.toLowerCase()) ||
              item.carModel?.toLowerCase().includes(filter.toLowerCase()) ||
              item.modelYear
                ?.toString()
                .toLowerCase()
                .includes(filter.toLowerCase()) ||
              item.countryCode
                ?.toString()
                .toLowerCase()
                .includes(filter.toLowerCase()) ||
              item.nationality?.toLowerCase().includes(filter.toLowerCase()) ||
              item.expiryDate?.toLowerCase().includes(filter.toLowerCase()) ||
              item.dateOfBirth?.toLowerCase().includes(filter.toLowerCase())
          )
          .sort((a, b) => {
            if (a.createdAt && b.createdAt) {
              return b.createdAt.localeCompare(a.createdAt);
            }
            return 0;
          });
      }
      return data[key].sort((a, b) => {
        if (a.createdAt && b.createdAt) {
          return b.createdAt.localeCompare(a.createdAt);
        }
        return 0;
      });
    }
  }

  public getAgencyId(): string | undefined {
    return window.localStorage.agencyId;
  }

  public setAgencyId(value: string): void {
    window.localStorage.agencyId = value;
  }

  public markAsProcessed(batchId: number, channel: "whatsapp" | "email"): void {
    const importedData = window.localStorage.importedData;
    if (importedData) {
      const data = JSON.parse(importedData);
      const agencyId = this.getAgencyId();
      const newData = data[agencyId].map((data: NewCustomer) => {
        if (data.batchId === batchId) {
          if (channel === "whatsapp") {
            return {
              ...data,
              canDelete: false,
              whatsAppStatus: "PROCESSED",
            };
          } else {
            return {
              ...data,
              canDelete: false,
              emailStatus: "PROCESSED",
            };
          }
        }
        return data;
      });
      data[agencyId] = newData;
      window.localStorage.importedData = JSON.stringify(data);
    }
  }
}
